export default function translations(){ 
  var locales = $("#translations").data('content') !== undefined ? $("#translations").data('content') : {}

  return locales
}